<custom-table [config]="customTable" [rowExpansionTemplate]="tableRowexpansion">
</custom-table>
<ng-template #tableRowexpansion let-data>
  <app-solicitud-historial-actividad [solicitudId]="data.id"
                                     class="app-card mx-auto border-1 border-top-none border-noround-top"/>
</ng-template>
